export default __webpack_public_path__ + "static/media/down.bff190e0.png";